import { useMemo } from "react";
import { Provider } from "react-redux";
import IndexSendListings from "./IndexSendListings";

interface IndexSendListingsAppProps {
  listing: object;
}

const IndexSendListingsApp = ({ listing }: IndexSendListingsAppProps) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <IndexSendListings listing={listing} />
    </Provider>
  );
};

export default IndexSendListingsApp;
